import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { setAgGridLicenseKey } from '@wdx/shared/components/ag-grid';
import { AuthenticationService } from './services/authentication.service';
import { BaseComponentClass } from './classes/base-component.class';
import { AccessVisibilityComponent } from './shared/features/access-visibility/access-visibility.component';
import { AccessVisibilityService } from './shared/features/access-visibility/shared/services/access-visibility.service';
import { CommentsService } from './shared/features/comments';
import { CommentsModalComponent } from './shared/features/comments/comments-modal/comments-modal.component';
import * as rootReducer from './state/_setup/reducers';
import * as globalSelectors from './state/global/global.selectors';
import { Observable } from 'rxjs';

setAgGridLicenseKey();

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false,
})
export class AppComponent extends BaseComponentClass implements OnInit {
    getAppIsReady$!: Observable<boolean>;
    isAuthenticated = false;

    @ViewChild('accessVisibility', { read: AccessVisibilityComponent })
    set accessVisibility(component: AccessVisibilityComponent) {
        this._accessVisibility = component;
        this.accessVisibilityService.setComponent(component);
    }
    get accessVisibility(): AccessVisibilityComponent {
        return this._accessVisibility;
    }
    _accessVisibility: AccessVisibilityComponent;

    @ViewChild('comments', { read: CommentsModalComponent })
    set commentsModal(component: CommentsModalComponent) {
        this._commentsModal = component;
        this.commentsService.setComponent(component);
    }
    get commentsModal(): CommentsModalComponent {
        return this._commentsModal;
    }
    _commentsModal: CommentsModalComponent;

    private readonly accessVisibilityService = inject(AccessVisibilityService);
    private readonly commentsService = inject(CommentsService);
    private readonly authService = inject(AuthService);
    private readonly authenticationService = inject(AuthenticationService);

    constructor() {
        super();

        this.authenticationService.auth0Service = this.authService;

        this.patchInjectedItems({
            actions$: inject(Actions),
            store$: inject(Store<rootReducer.State>),
        });
    }

    ngOnInit() {
        this.authenticationService.auth0Service.isAuthenticated$.subscribe(
            (isAuthenticated) => {
                this.isAuthenticated = isAuthenticated;
            },
        );

        this.getAppIsReady$ = this.store$.select(globalSelectors.getAppIsReady);
    }

    isAppInitialising(isAppInitialised: boolean): boolean {
        return !isAppInitialised;
    }
}
